import React, { useEffect } from "react";
import "./UserActivity.css";
let _ = require("lodash");

const UserActivity = (props) => {
  console.log("UserActivity 1");
  useEffect(()=>{
    console.log("UserActivity 2");
  })
  
  useEffect(()=>{
    console.log("UserActivity 3");
  },[])

  return (
    <div className="container-fluid">
      User Activity
    </div>
  );
};

export default UserActivity;
